module.exports = __webpack_public_path__ + "media/music/bells_7-6152eb68.mp3";